import { BOOKING_URL_PARAMS } from "@/pages/dashboard/campaign-manager/booking/lib/urlParams"

import routes from "./routes"

const P = BOOKING_URL_PARAMS

/**
 * The booking step that shows each step of the retired v1 wizard (its `step` param). A missing,
 * unknown or `confirmation` step opens Select: the wizard had no confirmation page of its own.
 */
const BOOKING_STEP_ROUTE = new Map<string, string>([
  ["mupis", routes["dashboard/campaign-manager/booking/select"]],
  ["content", routes["dashboard/campaign-manager/booking/content"]],
  ["review", routes["dashboard/campaign-manager/booking/review"]],
  ["payment", routes["dashboard/campaign-manager/booking/payment"]],
])

/**
 * Where an old v1 booking URL (`/dashboard/campaign-manager/mupi-selection?…`) now opens. The step
 * moves from the query into the path; everything else in the query is kept, so the search's
 * location, dates, centre and any other parameter arrive unchanged. Links older than MPE-1305 carry
 * the centre only as `centerLat`/`centerLng`, which booking reads as `lat`/`lng`.
 */
export function legacyBookingTarget(search: string): { pathname: string; search: string } {
  const params = new URLSearchParams(search)
  const step = params.get(P.step)
  params.delete(P.step)
  const centerLat = params.get(P.centerLat)
  const centerLng = params.get(P.centerLng)
  if (!params.has(P.lat) && !params.has(P.lng) && centerLat && centerLng) {
    params.set(P.lat, centerLat)
    params.set(P.lng, centerLng)
  }
  const query = params.toString()
  return {
    pathname: (step && BOOKING_STEP_ROUTE.get(step)) || routes["dashboard/campaign-manager/booking/select"],
    search: query ? `?${query}` : "",
  }
}
